import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { DistrictAdministrationService } from "../services/districtadministration.service";
import { DistrictAddSchoolComponent } from "./district-add-school/district-add-school.component";
import { DistrictEditSchoolComponent } from "./district-edit-school/district-edit-school.component";

@Component({
	selector: "app-district-school-maintenance",
	templateUrl: "./district-school-maintenance.component.html",
	styleUrls: ["./district-school-maintenance.component.css"],
})
export class DistrictSchoolMaintenanceComponent implements OnInit {
	constructor(private userService: UserService, private districtadministrationService: DistrictAdministrationService, private dialogService: DialogService) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadSchools();
		this.loadAddPref();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////
	user: any;

	pagerows: any = 10;
	pagefirst: any = 0;

	SelectedSchool: any;
	lstSchools: any = [];

	//Filter lists
	lstSchoolTypeDesc: any = [];
	lstActiveDesc: any = [];
	lstCity: any = [];
	lstState: any = [];

	cols: any = [
		{ field: "SchoolName", header: "School Name" },
		{ field: "SchoolTypeDesc", header: "School Type" },
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "Street", header: "Street" },
		{ field: "City", header: "City" },
		{ field: "State", header: "State" },
		{ field: "Phone", header: "Phone" },
		// { field: 'Active', header: 'Active' }
	];

	loading: any = false;
	errorMessage: any = "";

	ToggleText: any = "Deactivate School";

	AddPref: any = false;
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	loadSchools() {
		this.loading = true;

		var result = this.districtadministrationService.LoadSchoolInfo(-1);
		result.subscribe(
			(response) => {
				this.lstSchools = response;

				for (var i = 0; i < this.lstSchools.length; i++) {
					this.lstSchools[i].ActiveDesc = this.lstSchools[i].Active == true ? "Active" : "Inactive";
				}

				this.lstSchoolTypeDesc = Array.from(new Set(this.lstSchools.map((item: any) => item.SchoolTypeDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstSchools.map((item: any) => item.ActiveDesc))).sort();
				this.lstCity = Array.from(new Set(this.lstSchools.map((item: any) => item.City))).sort();
				this.lstState = Array.from(new Set(this.lstSchools.map((item: any) => item.State))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	//Check Preference (Can users add schools?)
	loadAddPref() {
		var result = this.districtadministrationService.LoadAddSchoolPref();
		result.subscribe(
			(response) => {
				this.AddPref = response;
			},
			(error) => {}
		);
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onRefresh() {
		this.loadSchools();
	}

	onAddSchool() {
		this.errorMessage = "";

		var ref = this.dialogService.open(DistrictAddSchoolComponent, {
			header: "Add School",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadSchools();
			}
		});
	}

	onEditSchool() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedSchool == undefined) {
			this.errorMessage = "Select a school to edit";
			return;
		}

		var ref = this.dialogService.open(DistrictEditSchoolComponent, {
			header: "Edit School",
			width: "fit-content",
			data: {
				SchoolID: this.SelectedSchool.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadSchools();
			}
		});
	}
	onToggleSchool() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedSchool == undefined) {
			this.errorMessage = "Select a school to set active or inactive";
			return;
		}

		var changeTo = 0;

		if (this.SelectedSchool.Active == false) {
			changeTo = 1;
		}

		var result = this.districtadministrationService.ToggleSchool(this.SelectedSchool.SchoolID, changeTo);
		result.subscribe(
			(response) => {
				this.loadSchools();
				this.onRowUnselect(null);
			},
			(error) => {}
		);
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedSchool = val.data;

		this.ToggleText = "Deactivate School";

		if (this.SelectedSchool.Active == false) {
			this.ToggleText = "Activate School";
		}
	}
	onRowUnselect(val) {
		this.SelectedSchool = null;

		this.ToggleText = "Deactivate School";
	}
	onRowDblClick(school) {
		this.SelectedSchool = school;
		this.onEditSchool();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////
	IsSU() {
		if (this.user == undefined || this.user.userID == undefined) {
			return false;
		}

		return this.user.userID == 0;
	}
	////////////////////////////////////////////
}
